import React from "react";
import {
    Camera,
    Star,
    MapPin,
    Bike,
    Circle,
    Wallet,
    Package
} from "lucide-react";

import "./ProfileHeader.css";

function ProfileHeader({ profile }) {

   const profileImage =
    profile?.profileImage
        ? profile.profileImage.startsWith("http")
            ? profile.profileImage
            : `https://homefoods-backend-production.up.railway.app${profile.profileImage}`
        : "/default-avatar.png";

    return (

        <div className="hf-profile-header">

            <div className="hf-profile-cover">

                <div className="hf-cover-overlay"></div>

            </div>

            <div className="hf-profile-body">

                <div className="hf-avatar-wrapper">

                    <img
                        src={profileImage}
                        alt="Profile"
                        className="hf-avatar"
                        onError={(e)=>{
                            e.target.src="/default-avatar.png";
                        }}
                    />

                    <button
                        type="button"
                        className="hf-camera-btn"
                    >

                        <Camera size={18}/>

                    </button>

                </div>

                <h2>

                    {profile?.name}

                </h2>

                <p className="hf-role">

                    HomeFoods Delivery Partner

                </p>

                <div className="hf-badges">

                    <div className="hf-badge">

                        <Star
                            size={16}
                            fill="#facc15"
                            color="#facc15"
                        />

                        {profile?.rating || "5.0"}

                    </div>

                    <div className="hf-badge">

                        <Bike size={16}/>

                        {profile?.vehicle?.type || "Bike"}

                    </div>

                    <div className="hf-badge">

                        <MapPin size={16}/>

                        {profile?.address?.city || "Bengaluru"}

                    </div>

                </div>

                <div className="hf-status">

                    <Circle
                        size={10}
                        fill={
                            profile?.online
                                ? "#22c55e"
                                : "#ef4444"
                        }
                        color={
                            profile?.online
                                ? "#22c55e"
                                : "#ef4444"
                        }
                    />

                    {profile?.online
                        ? "Online"
                        : "Offline"}

                </div>

                <div className="hf-stats">

                    <div className="hf-stat">

                        <Wallet size={24}/>

                        <h3>

                            ₹{profile?.earnings?.total || 0}

                        </h3>

                        <span>

                            Earnings

                        </span>

                    </div>

                    <div className="hf-stat">

                        <Package size={24}/>

                        <h3>

                            {profile?.statistics?.totalDeliveries || 0}

                        </h3>

                        <span>

                            Deliveries

                        </span>

                    </div>

                    <div className="hf-stat">

                        <Star size={24}/>

                        <h3>

                            {profile?.rating || "5.0"}

                        </h3>

                        <span>

                            Rating

                        </span>

                    </div>

                </div>

            </div>

        </div>

    );

}

export default ProfileHeader;